import { BoxProps } from 'grommet';
import { RightStatus } from 'lib/api';

export const getAnimProps = (
  delay = 0,
  type?:
    | 'slideDown'
    | 'fadeIn'
    | 'fadeOut'
    | 'jiggle'
    | 'pulse'
    | 'slideUp'
    | 'slideLeft'
    | 'slideRight'
    | 'zoomIn'
    | 'zoomOut',
  duration = 300,
  withFadeIn = true
): BoxProps['animation'] =>
  withFadeIn
    ? [{ type: 'fadeIn' }, { type: type || 'slideDown', size: 'large', duration: 300, delay }]
    : { type: type || 'slideDown', size: 'large', duration, delay };

export const getRightStatusColor = (status?: RightStatus): string => {
  switch (status) {
    case RightStatus.ACTIVE:
      return 'status-ok';
    case RightStatus.EXPIRED:
      return 'status-critical';
    case RightStatus.RELEASED:
      return 'dark-3';
    default:
      return '';
  }
};
